import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Card, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import base from '../../apis';
import { toast } from 'react-toastify';
import Spinner from '../../components/Spinner/Spinner';
const useStyles = makeStyles((theme) => ({
  root: {
    padding: '20px 0',
  },
  card: {
    padding: '10px',
    cursor: 'pointer',
  },
}));

function MyOffices() {
  const classes = useStyles();
  const marketer_id = useSelector((state) => state.auth.marketerDetails.id);
  const [isLoading, setIsLoading] = useState(false);
  const [offices, setOffices] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    base
      .get(`/operations/marketers/${marketer_id}/offices/?status=incomplete`)
      .then(({ data }) => {
        setOffices(data);
        if (data.length === 0) {
          toast.info('You have no incomplete offices');
        }
      })
      .catch((err) => {
        toast.warn('Could not get offices');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [marketer_id]);

  const onGoToOffice = ({ id, branch, address, state, web_link }) => {
    navigate(`/office/${id}`, {
      state: { branch, address, state, web_link },
    });
  };
  return (
    <>
      {isLoading && <Spinner />}
      <Box className={classes.root}>
        <Grid container spacing={2}>
          {offices.map((office) => {
            return (
              <Grid item xl={4} key={office.id}>
                <Card className={classes.card} onClick={() => onGoToOffice(office)}>
                  <Typography paragraph fontWeight={700}>
                    {office.branch}
                  </Typography>
                  <Typography paragraph>{office.address}</Typography>
                  <Typography paragraph>
                    {office.city}, {office.state.toUpperCase()}
                  </Typography>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </>
  );
}

export default MyOffices;
